module.exports = __webpack_public_path__ + "img/indian-navy.19f53e4f.jpg";